// extracted by mini-css-extract-plugin
module.exports = {"list":"CurrencyDropdown_list__t4OsU","listItem":"CurrencyDropdown_listItem__p_1vm"};